export default __webpack_public_path__ + "static/media/brad schneider.c04ff846.jpg";